import * as _ from 'lodash';

angular.module('cian.highwaysService', [])
.factory('HighwaysService', ["$http", "$q", "SearchCacheService", "RegionUtilsService", "RegionIds", function ($http, $q, SearchCacheService, RegionUtilsService, RegionIds) {
  var service = {};

  /**
   * @memberOf HighwaysService
   * @param {number} regionId
   * @return {object[]}
   */
  service.getHighways = function (regionId) {
    var def = $q.defer();

    $http
      .get('/api/geo/get-roads/?regionId=' + regionId, { cache: true })
      .then(response => {
        def.resolve(response.data.map(direction => {
          return {
            name: direction.name,
            highways: direction.highways.map(highway => ({
              type: 'highway',
              id: highway.id,
              text: highway.name
            }))
          };
        }));
      })
      .catch(def.reject);

    return def.promise;
  };

  // Если добавленный тег – это улица, но в названии есть «шоссе»
  service.streetIsHighway = function (tag) {
    return (tag.text.indexOf(' шоссе') > -1 && tag.type === 'street');
  };


  function extractHighwayNameFromStreet(text) {
    var re = /([а-яё]+)(?: шоссе)/ig,
      match = re.exec(text);
    return match ? match[1] : '';
  }

  function yoToYe(str) {
    return str.replace(/ё/ig, 'е');
  }

  function makeTagFromHighway(id, text) {
    return {
      id: id,
      type: 'highway',
      text: text + ' шоссе'
    };
  }

  function compareHighwayNames(nameA, nameB) {
    return yoToYe(nameA.toLowerCase()) === yoToYe(nameB.toLowerCase());
  }

  service.getHighwayFromStreet = function(street, selectedRegions) {
    const def = $q.defer();
    /**
     * Регион, для которого ищем шоссе
     * @type {Region}
     */
    let highwayRegion;
    // У некоторых шоссе в качестве родителя указана Москва,
    // а к API шоссе нужно делать запрос с МО
    if (RegionUtilsService.isMoscowOrMO(selectedRegions)) {
      highwayRegion = RegionUtilsService.getTopRegion(RegionIds.REGIONS.MO);
    } else {
      highwayRegion = RegionUtilsService.findRegionWithHighway(selectedRegions);
    }
    const highwayName = extractHighwayNameFromStreet(street.text);

    service.getHighways(highwayRegion.id)
      .then(directions => {
        const highways = _.flatten(_.map(directions, 'highways'));
        const foundHighway = _.find(highways, h => compareHighwayNames(h.text, highwayName));

        if (foundHighway) {
          def.resolve(makeTagFromHighway(foundHighway.id, foundHighway.text));
        } else {
          def.reject();
        }
      });

    return def.promise;
  };

  return service;
}])
.factory('SearchCacheService', ["$cacheFactory", function($cacheFactory) {
  return $cacheFactory('searchData');
}]);



// WEBPACK FOOTER //
// ./src/components/highways-service/src/scripts/cian.highwaysService.js